"use strict";

import React from "react";
import Screen from "./screen.js";
import { createRoot } from "react-dom/client";

const createElement = React.createElement;
export { Screen, createElement, createRoot };
